module.exports = __webpack_public_path__ + "img/codes.c215ccf5.jpg";